import { useTranslation } from '@/i18n';
import { GenderOptions } from '@/types/profile';
import type { TFunction } from 'i18next';
import { useMemo } from 'react';

export const getGenderOptions = (t: TFunction) => {
  const genderMap: Record<GenderOptions, string> = {
    [GenderOptions.MALE]: t('text.male'),
    [GenderOptions.FEMALE]: t('text.female'),
    [GenderOptions.X]: t('text.other'),
  };

  return Object.values(GenderOptions).map((value) => ({
    value,
    label: genderMap[value],
  }));
};

export const useGenderOptions = () => {
  const { t } = useTranslation();

  return useMemo(() => getGenderOptions(t), [t]);
};
